<template>
  <div :class="{ 'weather-live': true, 'weather_light': theme == 'light' }">
    <div class="header">
      <span v-for="item in tableHeader" :key="item">{{ item }}</span>
    </div>
    <div class="body-content" ref="riskRef1" @mouseover="mouseover" @mouseout="mouseout">
      <div class="body-item" v-for="item, index in tableData" :key="index">
        <el-tooltip class="item" effect="dark" :content="item.objname" placement="right">
          <span>{{ item.objname }}</span>
        </el-tooltip>
        <span>{{ item.t }}℃</span>
        <span>{{ item.hourrf }}mm</span>
        <span>{{ item.r03h }}mm</span>
        <span>{{ item.r24h }}mm</span>
      </div>
    </div>
  </div>
</template>

<script>
import { apiData } from '@/api'
import { findWind } from '@/utils/tool.js'
export default {
  props: {
    theme: {
      type: String,
      default: 'light'
    }
  },
  data() {
    return {
      tableHeader: ['地点', '温度', '1小时雨量', '3小时雨量', '24小时雨量'],
      tableData: [],
      timmer: null
    }
  },
  mounted() {
    this.getGiftLive()

    this.$nextTick(() => {
      setTimeout(() => {
        const riskRef = this.$refs.riskRef1
        const scrollHeight = riskRef.scrollHeight - riskRef.offsetHeight
        if (scrollHeight > 0) {
          this.startTimmer(riskRef, scrollHeight)
        }
      }, 2000)
    })
  },
  methods: {
    async getGiftLive() {
      const company = this.$route.query.company
      const { unit } = JSON.parse(localStorage.getItem(company))
      const result = await apiData.getObjRainSort(unit.id)
      if (result.status === 200) {
        this.tableData = result.data.map(item => {
          item.windd = findWind(item.windd)
          return item
        })
      }
      this.$emit('changeTime', this.$moment(this.tableData[0].timeLong).format('YYYY-MM-DD HH:mm'))
    },
    startTimmer(riskRef, scrollHeight) {
      if (this.timmer) {
        clearInterval(this.timmer)
      }
      this.timmer = setInterval(() => {
        riskRef.scrollTo({
          top: riskRef.scrollTop + 1
        })
        if (riskRef.scrollTop > (scrollHeight - 3)) {
          clearInterval(this.timmer)
          setTimeout(() => {
            riskRef.scrollTo({
              top: 0
            })
            setTimeout(() => {
              this.startTimmer(riskRef, scrollHeight)
            }, 2000)
          }, 2000)
        }
      }, 15)
    },

    mouseover() {
      if (this.timmer) {
        clearInterval(this.timmer)
      }
    },
    mouseout() {
      const riskRef = this.$refs.riskRef1
      const scrollHeight = riskRef.scrollHeight - riskRef.offsetHeight
      if (scrollHeight > 0) {
        this.startTimmer(riskRef, scrollHeight)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.weather-live {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  left: 0;
  top: 0;
  z-index: 99;
  overflow: hidden;
  padding-top: 0.63vw;

  .header {
    display: flex;
    align-items: center;
    height: 2.71vw;
    margin-left: 1.11vw;
    background: #244274;
    border-radius: 0.21vw;

    span {
      flex: 1;
      text-align: center;
      font-size: 0.73vw;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 1.04vw;
    }
  }

  .body-content {
    flex: 1;
    padding-bottom: 3px;
    overflow: hidden;
    overflow-y: auto;

    .body-item {
      display: flex;
      align-items: center;
      height: 2.71vw;
      margin-left: 1.11vw;

      span {
        flex: 1;
        text-align: center;
        font-size: 0.73vw;
        color: #FFFFFF;
        line-height: 1.04vw;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
}

::-webkit-scrollbar-track {
  background: #E7E7E7;
  border-radius: 1.09vw;
}

::-webkit-scrollbar-thumb {
  background: #D8D8D8;
  border-radius: 1.09vw;
  height: 1.56vw;
}

::-webkit-scrollbar {
  width: 0.52vw;
}

.body-content::-webkit-scrollbar-track {
  background: #0C355F;
}

.body-content::-webkit-scrollbar-thumb {
  background: #3a71a7;
}

.weather_light {
  .header {
    background: #ECF0F7;

    span {
      color: #333333;
    }
  }

  .body-content {
    .body-item {
      span {
        color: #333333;
      }
    }
  }

  .body-content::-webkit-scrollbar-track {
    background: #E7E7E7;
  }

  .body-content::-webkit-scrollbar-thumb {
    background: #D8D8D8;
  }
}
</style>
